import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ActivePanelEnum, PartyRolesEnum } from '@app/core/enums';
import { PartyTypesEnum } from '@app/core/enums/party-types.enum';
import { ActivePanelInterface, PendingActionInterface } from '@app/core/interfaces';
import { PanelService } from '@app/shared/services/panel.service';
import { PanelExpandableComponent } from '@app/shared/ux/panel-expandable/panel-expandable.component';

@Component({
    selector: 'ins-pending-actions',
    templateUrl: './pending-actions.component.html',
    styleUrls: ['./pending-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PendingActionsComponent {
    @Input() actions: PendingActionInterface;
    @Input() children: QueryList<PanelExpandableComponent>;
    public partyEnum = PartyRolesEnum;
    public activePanelEnum = ActivePanelEnum;
    private index: number;

    constructor(private panelService: PanelService, private router: Router, private cdRef: ChangeDetectorRef) {}

    public toggle(props: { scrollTo: string; panel: string }): boolean {
        this.router.navigate([], {
            queryParams: {
                ...props,
            },
            queryParamsHandling: 'merge',
        });
        this.panelService.handleQueryParams(props as ActivePanelInterface, this.children, this.cdRef);
        return false;
    }

    public getIndex(): number {
        return this.index++;
    }

    public setInitialIndex(): boolean {
        this.index = 1;
        return true;
    }
}
